import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
      options: {
        customProperties: true,
      },
  themes: {
      light: {
        primary: '#e8e5da',
        secondary: '#9eb7e5',
        accent: '#304c89',
        //error: '#FF5252',
        //info: '#2196F3',
        //success: '#9eb7e5',
        warning: '#993030'
      },
      dark: {
        primary: '#ee44aa',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    },
  },
});
